var map = {
	"./approved_icon_thin.svg": [
		108
	],
	"./beware_of_the_origin.svg": [
		1264,
		5
	],
	"./comes_from_profit.svg": [
		1265,
		6
	],
	"./comes_from_success.svg": [
		1266,
		7
	],
	"./commitment_to_the_climate.svg": [
		1267,
		8
	],
	"./eco_friendly_packaging.svg": [
		1268,
		9
	],
	"./error_sad_icon.svg": [
		437
	],
	"./natural_formulas.svg": [
		1269,
		10
	],
	"./no_animal_testing.svg": [
		1270,
		11
	],
	"./outlined_content_handbag.svg": [
		1271,
		12
	],
	"./outlined_content_indicator.svg": [
		1272,
		13
	],
	"./outlined_content_medal.svg": [
		1273,
		14
	],
	"./outlined_product_brandsproduct.svg": [
		1274,
		15
	],
	"./pending_icon.svg": [
		434
	],
	"./pending_icon_elo.svg": [
		435
	],
	"./processing_icon_thin.svg": [
		439
	],
	"./rejected_icon.svg": [
		436
	],
	"./rejection_icon.svg": [
		440
	],
	"./safe_for_you_and_environment.svg": [
		1275,
		16
	],
	"./warning.svg": [
		438
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1234;
module.exports = webpackAsyncContext;